// React&NextJS
import React from 'react'
import Link from 'next/link'
// Styles
import s from './Breadcrumbs.module.scss'
// Components
import { Container } from '../../core/container/Container'
import { Icon } from '../../core/icon/Icon'
import { Text } from '../../core/text/Text'
// Hooks
import trimText from '../../../hooks/useTrimText'

type Props = {
    className?: string
    breadcrumbs: Array<Breadcrumb>
}

type Breadcrumb = {
    name: string
    href?: string
}

const Breadcrumbs = ({ breadcrumbs }: Props) => {
    return (
        <Container>
            <div className={s.crumbs}>
                {breadcrumbs.map((crumb, i) => {
                    const text = trimText(crumb.name, 25, 45, 65)[0]

                    if (breadcrumbs.length != i + 1) {
                        return (
                            <div key={i} className={s.crumb}>
                                <>
                                    {i != 0 && (
                                        <Icon
                                            className={s.icon}
                                            variant="crumbArrow"
                                        />
                                    )}
                                    <Text variant="p-small">
                                        <Link href={crumb.href}>{text}</Link>
                                    </Text>
                                </>
                            </div>
                        )
                    } else {
                        return (
                            <div key={i} className={s.activeCrumb}>
                                <Icon className={s.icon} variant="crumbArrow" />
                                <Text variant="p-small">{text}</Text>
                            </div>
                        )
                    }
                })}
            </div>
        </Container>
    )
}

export default Breadcrumbs
